import { render } from "./FeatherBellSvg.vue?vue&type=template&id=3af4b4cc"
const script = {}
script.render = render

export default script